import { render, staticRenderFns } from "./GenericAddButton.vue?vue&type=template&id=661de23a"
import script from "./GenericAddButton.vue?vue&type=script&lang=js"
export * from "./GenericAddButton.vue?vue&type=script&lang=js"
import style0 from "./GenericAddButton.vue?vue&type=style&index=0&id=661de23a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports